import { composeQuery, Query } from '../models/query';
import { DataResponse, PageableResponse, Subscription, TrueUpgradeInfo } from '../models';
import { ceV2Axios } from './axios';

export const toggleAutoRenew = async (recurlySubscriptionId: number) => (await ceV2Axios.put<boolean>(`/subscriptions/toggle-auto-renewal/${recurlySubscriptionId}`)).data;

export const getSubscriptions = async (...criteria: Query<Subscription>[]) => (
  await ceV2Axios.get<PageableResponse<Subscription>>('/subscriptions', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<Subscription>(...criteria),
    data: {},
  })
).data.data;

export const reserveUpgradeToTruePlatform = async () => (await ceV2Axios.post<DataResponse<TrueUpgradeInfo>>('/subscriptions/true-platform/upgrade/reserve')).data;

export const upgradeToTruePlatform = async () => (await ceV2Axios.post<DataResponse<Subscription>>('/subscriptions/true-platform/upgrade')).data;

export const getTruePlatformUpgradeInfo = async () => (await ceV2Axios.get<DataResponse<TrueUpgradeInfo>>('/subscriptions/true-platform/upgrade')).data;
